export default [
  {
    name: 'Indonesia',
		currency: 'IDR', //ISO 4217 (https://en.wikipedia.org/wiki/ISO_4217)
		currrencySymbol: 'Rp',
		threeLetterCode: 'IDN', //ISO 3166-1 alpha-3 (https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
	},
	{
		name: 'Singapura',
		currency: 'SGD', //ISO 4217 (https://en.wikipedia.org/wiki/ISO_4217)
		currrencySymbol: '$',
		threeLetterCode: 'SGP', //ISO 3166-1 alpha-3 (https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
	},
	{
		name: 'Malaysia',
		currency: 'MYR', //ISO 4217 (https://en.wikipedia.org/wiki/ISO_4217)
		currrencySymbol: 'RM',
		threeLetterCode: 'MYS', //ISO 3166-1 alpha-3 (https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
	},
	{
		name: 'United States',
		currency: 'USD', //ISO 4217 (https://en.wikipedia.org/wiki/ISO_4217)
		currrencySymbol: '$',
		threeLetterCode: 'USA', //ISO 3166-1 alpha-3 (https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
	}
]

// example how to find country by its three letter code
// const country = countries.find(country => country.threeLetterCode === 'IDN')